import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgExtraction = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 17 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M8.30586 1.80476C9.63863 1.80476 13.1049 -0.118494 15.1071 1.98137C16.7114 3.66421 16.1189 7.71066 14.9692 10.4346C14.5413 11.4477 14.5598 12.704 14.6454 13.8779C14.9892 18.5799 13.4553 25.8182 12.0531 25.7335C10.6153 25.6464 10.7441 17.0265 8.57355 16.2744C7.30545 15.835 7.0097 18.0952 6.72822 20.2118C6.39158 22.7439 6.58985 25.3884 5.87425 25.6597C5.04121 25.9753 3.46072 23.855 2.62102 20.0037C2.16979 17.9343 1.97532 15.5964 2.03238 13.9069C2.06947 12.8135 2.07089 11.4481 1.64296 10.4351C0.492776 7.71161 -0.099672 3.66469 1.50507 1.98185C3.50732 -0.118018 6.97356 1.80523 8.30633 1.80523L8.30586 1.80476Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinejoin="round"
    />
    <path
      d="M6.24544 4.19354L8.26559 7.55301H8.33726L10.3664 4.19354H12.2611L9.43469 8.78033L12.3059 13.3671H10.3798L8.33726 10.0301H8.26559L6.22304 13.3671H4.30591L7.204 8.78033L4.34174 4.19354H6.24544Z"
      fill={props.findingsFill || '#FF5140'}
    />
  </svg>
);
export default SvgExtraction;
